import React from "react";
import { Download } from "lucide-react";
import { useInstallPrompt } from "../hooks/useInstallPrompt";

const COPY = {
  auth: {
    title: "Install Heldall",
    body: "Open it from your home screen when you need to put something down.",
  },
  account: {
    title: "Add Heldall to your home screen",
    body: "Faster capture, no browser bar.",
  },
};

// Production install affordance. Renders nothing unless the browser is eligible
// (beforeinstallprompt fired, not standalone, not recently dismissed).
export function InstallAffordance({ variant = "auth", className = "" }) {
  const { eligible, promptInstall, dismiss } = useInstallPrompt();
  if (!eligible) return null;

  const { title, body } = COPY[variant] || COPY.auth;

  return (
    <div
      data-testid={`install-affordance-${variant}`}
      className={`rounded-2xl bg-[var(--surface2)] border border-[var(--line)] px-5 py-4 flex items-start gap-3 ${className}`}
    >
      <span className="mt-0.5 h-9 w-9 shrink-0 rounded-full bg-[var(--pine-soft)] flex items-center justify-center text-[var(--pine)]">
        <Download size={16} strokeWidth={1.9} />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-[var(--ink)] font-medium text-sm">{title}</p>
        <p className="text-sm text-[var(--ink3)] mt-0.5 leading-relaxed">{body}</p>
        <div className="flex items-center gap-2 mt-3">
          <button
            type="button"
            data-testid={`install-app-btn-${variant}`}
            onClick={promptInstall}
            className="inline-flex items-center gap-1.5 rounded-full bg-[var(--pine)] hover:bg-[var(--pine-dark)] text-[var(--on-pine)] font-semibold px-4 py-2 text-xs transition-colors duration-200"
          >
            Install app
          </button>
          <button
            type="button"
            data-testid={`install-dismiss-btn-${variant}`}
            onClick={dismiss}
            className="rounded-full px-3 py-2 text-xs font-semibold text-[var(--ink3)] hover:text-[var(--ink2)] transition-colors duration-200"
          >
            Not now
          </button>
        </div>
      </div>
    </div>
  );
}
